import { InvoiceCheckoutItemModel } from "./invoice-checkout-item-model";
import { InvoiceCheckoutModel } from "./invoice-checkout-model";

export const mapInvoiceData = (source: any, payId: number): InvoiceCheckoutModel => {
  const grossAmount: number = source.orderInvoice.length>0
  ?source.taxableAmount + source.taxAmount - source.discountAmount
  :source.taxableAmount + source.taxAmount - source.discountAmount 
   + source.paymentGatewayCharges + source.courierCharges + source.handlingCharges + source.packingCharges;

  const mappedInvoiceItems: InvoiceCheckoutItemModel[] =
  source.orderInvoiceDetail
    .filter((item: any) => item.pendingQuantity !== 0) // Filter out items with pendingQuantity 0
    .map((item: any) => ({
      orderDetailID: item.orderDetailID,
      invoicedQuantity: item.pendingQuantity,
      totalAmount: Math.round(
        item.unitPrice * item.pendingQuantity +
          (item.unitPrice * item.pendingQuantity * item.gst) / 100
      ),
    }));
  
  return {
    orderID: source.orderID,
    posID: source.posID,
    taxableAmount: source.taxableAmount,
    taxAmount: source.taxAmount,
    discountAmount: source.discountAmount,
    paymentGatewayCharges: source.paymentGatewayCharges,
    grossAmount: Math.round(grossAmount),
    paymentModeID: payId,
    orderInvoiceDetail: mappedInvoiceItems
  };
}
